module.exports = __webpack_public_path__ + "images/icons_v2/others-7cb515db.svg";